import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { SharedModule } from "app/shared/shared.module";
import { FoundMedicationIncidentModel } from "../../services/found-medication-incident-model.service";
import { MedicationIncidentListItemComponent } from "../../components/medication-incident-list-item/medication-incident-list-item.component";

@Component({
	imports: [SharedModule, IonicModule, MedicationIncidentListItemComponent],
	providers: [FoundMedicationIncidentModel],
	templateUrl: "./incident-list.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: ["./incident-list.component.scss"],
})
export class IncidentListComponent {
	private readonly router = inject(Router);
	private readonly foundMedicationIncidentModel = inject(FoundMedicationIncidentModel);

	protected foundMedicationIncidents = this.foundMedicationIncidentModel.foundMedicationIncidents;

	protected gotoCreateFoundMedicationIncident() {
		this.router.navigate(["found-medication-incident", "create"]);
	}
}
